import { Client } from '@skyrise-eng/types';
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

// Define a service using a base URL and expected endpoints
export const clientApi = createApi({
  reducerPath: 'clientApi',
  baseQuery,
  endpoints: (builder) => ({
    getClientList: builder.query<Client[], void>({
      query: () => '/clients/api/v1'
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetClientListQuery } = clientApi;
